import React, { useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../../components/CustomDateRangePicker/CustomDateRangePicker";
import "./ClientsOverview.css";
import { useSelector, useDispatch } from "react-redux";
import * as _ser from "../../../_redux/_services/ClientsSlice";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import ClientsCreate from "../ClientsCreate/ClientsCreate";
import * as _appSer from "../../../_redux/_services/ApplicantsSlice";
import InlineActions from "../../../components/InlineActions/InlineActions";
import { ApplicantEditIcon } from "../../../Icons/ApplicantEditIcon";
import { ApplicantDeleteIcon } from "../../../Icons/ApplicantDeleteIcon";
import WarningPopup from "../../../components/WarningPopup/WarningPopup";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import { ClientListfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import { refreshOutlet } from "../../../_redux/Uislice";

const initalState = { data: null, message: "", isloader: true };

const ClientsOverview = ({ clientData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [dateRange, setDateRange] = React.useState({
    startDate: dayjs().subtract(7, "day").toDate(),
    endDate: new Date(),
  });
  const [isRightSidePannel, setIsRightSidePannel] = React.useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = React.useState(false);
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  const client = useSelector((state) => state.GetClients.data);
  const summary = useSelector((state) => state.GetClients.summary);
  const jobStatusData = useSelector(
    (state) => state.JobStatusByClient?.data?.[""],
  );
  const editCode = useSelector((state) => state.EditClients.data);

  const getJobStatusByClientData = (dates) => {
    const requestBody = {
      client: id,
      widgetId: "",
      status: "Active,On-Hold,Filled,Closed",
      startDate: dates?.startDate,
      endDate: dates?.endDate,
    };
    dispatch(_appSer.getJobStatusByClientAsync(requestBody));
  };

  let DelClientscode = useSelector((state) => state.DeleteClients.data);

  const DeleteRecords = async (object) => {
    let ids;
    if (typeof object === "object" && object.length > 0) {
      ids = object.map((x) => x.id.toString());
    } else {
      ids = [object.toString()];
    }
    let obj = { ids: ids };
    dispatch(_ser.deleteClientsAsync(obj));
  };

  useEffect(() => {
    if (DelClientscode === 200) {
      dispatch(_ser.deleteClientsStartReducer(initalState));
      navigate("/ats/layout/clients/landing");
    }
  }, [DelClientscode]);

  useEffect(() => {
    if (id) {
      dispatch(_ser.getClientsAsync(id));
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const dates = {
        startDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
        endDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
      };
      getJobStatusByClientData(dates);
    }
  }, [id, dateRange]);

  useEffect(() => {
    if (editCode === 200) {
      setIsRightSidePannel(false);
      dispatch(_ser.editClientsStartReducer(initalState));
      dispatch(_ser.getClientsAsync(id));
      dispatch(refreshOutlet());
    }
  }, [editCode]);

  const handleDateChange = (range) => {
    setDateRange(range);
  };

  const handleReceiveActionHandler = (type) => {
    if (type === "edit") {
      setIsRightSidePannel(true);
    } else if (type === "delete") {
      setIsDeletePopupOpen(true);
    }
  };

  const handleUpdate = (values) => {
    dispatch(_ser.editClientsAsync(id, values));
  };

  const getStatusColor = (label) => {
    switch (label) {
      case "Active":
        return "#dcc882";
      case "Closed":
        return "#8e8e8e";
      case "Filled":
        return "#e76f51";
      case "On-Hold":
        return "#9fbb7d";
      default:
        return "#ccc";
    }
  };

  const getMappedClientData = (data) => {
    if (!data) return {};
    return {
      clientName: data.clientName,
      location: data.location,
      contactName: data.contactName,
      phoneNumber: data.phoneNumber,
      managerEmail: data.emailId,
      websiteURL: data.website,
      isContractSigned: data.isContractSigned,
      region: data.region,
      status: data.status,
      notes: data.notes,
      id: data.id,
      customFields: data.customFields,
    };
  };

  const formattedJobStatus =
    jobStatusData?.map((item, index) => ({
      id: index,
      value: item.count,
      label: item.status,
      color: getStatusColor(item.status),
    })) || [];

  const chartData = formattedJobStatus.filter((item) => item.value > 0);
  const totalStatusCount = chartData.reduce((acc, curr) => acc + curr.value, 0);

  const stats = [
    {
      label: `${summary?.totalEndClients || 0} End Clients`,
      icon: process.env.PUBLIC_URL + "/assests/img/OverviewIcon1.svg",
      colorClass: "blue",
    },
    {
      label: `${summary?.totalHiringManagers || 0} Hiring Manager's`,
      icon: process.env.PUBLIC_URL + "/assests/img/OverviewIcon2.svg",
      colorClass: "purple",
    },
    {
      label: `${summary?.activeRequirements || 0} Open Requirements`,
      icon: process.env.PUBLIC_URL + "/assests/img/OverviewIcon3.svg",
      colorClass: "green",
    },
  ];

  return (
    <Box className="clients-overview">
      <Box className="overview-header">
        <FloatingMenu
          floatingMenuOptions={ClientListfloatingMenuOptions}
          onReceiveActionHandler={handleReceiveActionHandler}
          storedTheme={storedTheme}
        />
      </Box>

      <Box className="stats-container">
        {stats.map((stat, index) => (
          <Card key={index} className="stats-card">
            <Box className={`stats-icon-wrapper ${stat.colorClass}`}>
              <img src={stat.icon} alt="icon" />
            </Box>
            <Typography className="stats-text">{stat.label}</Typography>
          </Card>
        ))}
      </Box>

      <Grid container spacing={3} className="client-details-grid">
        <Grid item xs={12} md={5}>
          <Box className="client-details-section">
            <Typography className="section-title">Client Details</Typography>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Client Name</Typography>
                  <Typography className="detail-value">
                    {client?.clientName || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Location</Typography>
                  <Typography className="detail-value">
                    {client?.location + ", " + client?.region || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Status</Typography>
                  <Chip
                    label={client?.status === "1" ? "Active" : "Inactive"}
                    className="status-chip"
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Contact Name</Typography>
                  <Typography className="detail-value">
                    {client?.contactName || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Email</Typography>
                  <Typography className="detail-value">
                    {client?.emailId || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">
                    Contact Number
                  </Typography>
                  <Typography className="detail-value">
                    {client?.phoneNumber || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Website</Typography>
                  <Typography className="detail-value">
                    {client?.website || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="detail-item">
                  <Typography className="detail-label">Contract</Typography>
                  <Box className="contract-badge">
                    <img
                      src={process.env.PUBLIC_URL + "/assests/img/contract.svg"}
                      alt="contract"
                      width={20}
                      height={20}
                    />
                    <Typography sx={{ fontWeight: 500 }}>
                      {client?.isContractSigned === "Yes"
                        ? `Signed on ${dayjs(client?.createdDate).format("YYYY-MM-DD")}`
                        : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box className="notes-container">
              <Typography className="notes-label">Client Notes</Typography>
              <Typography
                className="notes-text"
                dangerouslySetInnerHTML={{ __html: client?.notes || "-" }}
              />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={7}>
          <Box className="job-status-section">
            <Box className="job-status-header">
              <Typography className="section-title">
                <img
                  src={process.env.PUBLIC_URL + "/assests/img/Jobstatus.svg"}
                  alt="jobStatus"
                  width={20}
                  height={20}
                />
                Job Status
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CustomDateRangePicker
                  handleDateChange={handleDateChange}
                  dateValue={dateRange}
                />
              </Box>
            </Box>

            <Box className="pie-chart-container">
              {totalStatusCount > 0 ? (
                <PieChart
                  series={[
                    {
                      data: chartData,
                      innerRadius: 2,
                      outerRadius: 130,
                      paddingAngle: chartData.length > 1 ? 0.5 : 0,
                      cornerRadius: 2,
                      cx: 150,
                    },
                  ]}
                  key={chartData.length}
                  width={500}
                  height={300}
                  slotProps={{
                    legend: {
                      direction: "column",
                      position: { vertical: "middle", horizontal: "right" },
                      padding: 0,
                      itemMarkWidth: 20,
                      itemMarkHeight: 20,
                      markGap: 10,
                      itemGap: 15,
                      labelStyle: {
                        fontSize: 16,
                        fontWeight: 500,
                        fill: "#444",
                      },
                    },
                  }}
                />
              ) : (
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 500,
                    color: "#666",
                  }}
                >
                  No data available
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>

      {isRightSidePannel && (
        <RightSideBar
          componentLayout={{
            title: "Edit Client Details",
          }}
          componentData={
            <ClientsCreate
              componentType="Edit"
              input={getMappedClientData(client)}
              onValidData={handleUpdate}
              onClose={() => setIsRightSidePannel(false)}
            />
          }
          onReceiveProps={() => setIsRightSidePannel(false)}
        />
      )}

      <WarningPopup
        open={isDeletePopupOpen}
        handleClose={() => setIsDeletePopupOpen(false)}
        handleConfirm={() => DeleteRecords(id)}
        details={{
          title: "Are you sure you want to delete this client?",
          btnName: "Delete",
        }}
      />
    </Box>
  );
};

export default ClientsOverview;
